// IMPORTANT: Note that with Redux, state should NEVER be changed.
import objectAssign from 'object-assign';
import { modalInitialState } from '../store/initialState';
import { clone } from './helper';
import { combineReducers } from 'redux';
import {
  SHOW_MODAL,
  HIDE_MODAL,
  UPDATE_SHOW_FORGET_PASSWORD_MODAL,
  UPDATE_SHOW_RESET_PASSWORD_TOKEN_MODAL,
  UPDATE_SHOW_CHANGE_PASSWORD_MODAL,
  UPDATE_SHOW_CHANGE_EMAIL_MODAL,
  UPDATE_SHOW_CHANGE_EMAIL_SUCCESS_MODAL,
  UPDATED_HIDE_WHEN_CLICK_AWAY_QUICK_VIEW,
  UPDATED_SHOW_QUICK_VIEW_MODAL,
  UPDATED_SHOW_CREATE_WAITING_AREA_MODAL,
  UPDATED_SHOW_UPDATE_WAITING_AREA_MODAL,
  UPDATED_SHOW_VIEW_WAITING_AREA_MODAL,
  UPDATED_SHOW_WEBSITE_BUTTON_WAITING_AREA_MODAL,
  UPDATED_SHOW_CREATE_MEETING_ROOM_MODAL,
  UPDATED_SHOW_VIEW_MEETING_ROOM_MODAL,
  UPDATED_SHOW_UPDATE_MEETING_ROOM_MODAL,
  UPDATED_SHOW_DELETE_MEETING_ROOM_MODAL,
  // Show edit meeting room properties modal
  SHOW_EDIT_MEETING_ROOM_MODAL,
  UPDATE_SHOW_INVITE_GUEST_MODAL,
  UPDATED_SHOW_VIEW_MEETING_ROOM_PARTICIPANT,
  UPDATED_SHOW_VIEW_WAITING_AREA_PARTICIPANT,
  UPDATED_SHOW_ADD_TO_CALL_WAITING_ARE_MODAL,
  UPDATED_SHOW_UPDATE_SMS_NOTIFICATION,
  UPDATED_SHOW_CREATE_SMS_NOTIFICATION,
  UPDATED_SHOW_NOTIFY_ROOM_PARTICIPANT,
  SHOW_CALL_HISTORY_MODAL,
  UPDATE_SHOW_USER_PROFILE_MODAL,
  UPDATE_SHOW_SUSPEND_WA_MODAL,
  UPDATE_SHOW_WA_SHARE_LINK_MSG_MODAL,
  UPDATED_SHOW_WAITING_AREA_BEFORE_CALLS_MODAL,
  UPDATED_SHOW_WAITING_AREA_BEFORE_CALLS_IMPORTANT_INFO_MODAL,
  UPDATE_SHOW_DURING_CALLS_MODAL,
  UPDATED_SHOW_VIEW_WAITING_AREA_OPERATING_HOURS_MODAL,
  UPDATED_SHOW_UPDATE_WAITING_AREA_OPERATING_HOURS_MODAL,
  UPDATE_SHOW_CALLER_ENTRY_POINT,
  UPDATED_SHOW_VIEW_WAITING_AREA_LOCAL_ACCESS_HOURS_MODAL,
  UPDATED_SHOW_UPDATE_WAITING_AREA_LOCAL_ACCESS_HOURS_MODAL,
  UPDATED_SHOW_WAITING_AREA_AFTER_CALLS_MODAL,
  SHOW_CONSULT_NOW_SETTING_MODAL,
  UPDATED_SHOW_WAITING_AREA_LOGO_PAUSE_IMAGE_MODAL,
  UPDATED_SHOW_ORGANISATIONAL_UNIT_LOGO_IMAGE_MODAL,
  // Copy link to Clipboard in Meeting Room
  SHOW_COPY_LINK_TO_CLIPBOARD_MODAL_FOR_MEETING_ROOM,
  UPDATED_SHOW_WAITING_AREA_ADD_USER_MODAL,
  UPDATED_SHOW_ORGANISATIONAL_UNIT_ADD_USER_MODAL,
  // Manage roles on users list
  SHOW_MANAGE_ROLES_FOR_USERS,
  SHOW_ORG_MANAGE_ROLES_FOR_USERS,
  UPDATE_SHOW_SET_MIN_DURATIONS_MODAL,
  UPDATED_SHOW_VIEW_WA_INVITE_SELF_PROVISION,
  EDIT_UPDATE_PORTAL_SETTING,
  UPDATED_SHOW_REGISTERED_USER_WITH_WA_MODAL,
  UPDATED_SHOW_WA_WELCOME_MODAL,
  // Shared Waiting Area settings
  SHOW_SUPPORT_CONTACT_MODAL,
  SHOW_INFO_FOR_CALLERS_MODAL,
  // Deactivate Waiting Area
  SHOW_DELETE_WA_MODAL,
  // Manage tags
  SHOW_REMOVE_TAG_CONFIRMATION_MODAL,
  SHOW_ASSIGN_TAGS_MODAL,
  SHOW_EDIT_TAG_VALUE_MODAL,
  // Manage tags in OU
  SHOW_REMOVE_TAG_CONFIRMATION_MODAL_IN_OU,
  SHOW_ASSIGN_TAGS_MODAL_IN_OU,
  SHOW_EDIT_TAG_VALUE_MODAL_IN_OU,
  // MANAGE My RoLES MODAL
  UPDATED_SHOW_MY_ROLES_MODAL,
  //END MANAGE MY ROLES MODAL

  // START ORG UNIT MODALS
  SHOW_ORG_UNIT_GENERAL_INFO_MODALS,
  SHOW_ORG_UNIT_SUPPORT_CONTACT_MODAL,
  SHOW_ORG_UNIT_BEFORE_CALLS_WA_MODAL,
  SHOW_ORG_UNIT_SHARE_LINK_WA_MODAL,
  SHOW_RECORDING_SETTING_MODAL,
  // END ORG UNIT MODALS
  // RESET MEETING ROOM GUEST LINK
  SHOW_MEETING_ROOM_RESET_GUEST_LINK_MODAL,
  // Meeting Room add users modal
  SHOW_MEETING_ROOM_ADD_USERS_MODAL,
  SHOW_MR_MANAGE_ROLES_FOR_USERS,
  SHOW_OTHER_USERS_PROFILE,
  SHOW_OTHER_USERS_ROLES,
  SHOW_CREATE_OU_MODAL,
  SHOW_MANAGE_INVITATIONS_MODAL,
  SHOW_SHARE_BY_EMAIL_WA,
  SHOW_SHARE_BY_TEXT_WA,
  SHOW_CONFIRMATION_CALL_MESS_MODAL,
  // Consult now
  SHOW_CONSULT_NOW_INVITATION,
  SHOW_CANCEL_CONSULT_NOW_INVITATION_MODAL,
  SHOW_EXTEND_CONSULT_NOW_INVITATION_MODAL,
  SHOW_WA_AUDIO_SETTING_MODAL,
  // GC settings
  SHOW_GC_SETTINGS_MODAL,
  SHOW_OU_DEFAULT_GC_SETTINGS_MODAL,
  SHOW_OU_WA_GC_SETTINGS_MODAL,
  // Delete Organization
  SHOW_DELETE_ORGANIZATION_MODAL,
} from '../actions/modal.js';

const reducer = (state = modalInitialState, action) => {
  switch (action.type) {
    case UPDATED_SHOW_ADD_TO_CALL_WAITING_ARE_MODAL:
      return objectAssign({}, state, {
        showAddToCallWaitingAreaModal: action.data,
      });
    case UPDATE_SHOW_FORGET_PASSWORD_MODAL:
      return objectAssign({}, state, { showForgetPasswordModal: action.data });
    case UPDATE_SHOW_RESET_PASSWORD_TOKEN_MODAL:
      return objectAssign({}, state, {
        showResetPasswordTokenModal: action.data,
      });
    case UPDATE_SHOW_CHANGE_PASSWORD_MODAL:
      return objectAssign({}, state, { showChangePasswordModal: action.data });
    case UPDATE_SHOW_CHANGE_EMAIL_MODAL:
      return objectAssign({}, state, { showChangeEmailModal: action.data });
    case UPDATE_SHOW_CHANGE_EMAIL_SUCCESS_MODAL:
      return objectAssign({}, state, {
        showChangeEmailSuccessModal: action.data,
      });
    case UPDATE_SHOW_USER_PROFILE_MODAL:
      return objectAssign({}, state, {
        showChangeUserProfileModal: action.data,
      });
    case UPDATED_SHOW_UPDATE_SMS_NOTIFICATION:
      return objectAssign({}, state, {
        showUpdateSmsNotification: action.data,
      });
    case UPDATED_SHOW_CREATE_SMS_NOTIFICATION:
      return objectAssign({}, state, {
        showCreateSmsNotification: action.data,
      });
    case UPDATED_SHOW_VIEW_WAITING_AREA_PARTICIPANT:
      return objectAssign({}, state, {
        showViewWaitingAreaParticipantModal: action.data,
      });
    case UPDATED_SHOW_CREATE_WAITING_AREA_MODAL:
      return objectAssign({}, state, {
        showCreateWaitingAreaModal: action.data,
      });
    case UPDATED_SHOW_WAITING_AREA_AFTER_CALLS_MODAL:
      return objectAssign({}, state, { showAfterCallsModal: action.data });
    case SHOW_CONSULT_NOW_SETTING_MODAL:
      return objectAssign({}, state, { showConsultNowSettingModal: action.data });
    case SHOW_WA_AUDIO_SETTING_MODAL:
      return objectAssign({}, state, { showWAAudioSettingModal: action.data });
    case UPDATED_SHOW_WAITING_AREA_BEFORE_CALLS_MODAL:
      return objectAssign({}, state, { showBeforeCallsModal: action.data });
    case UPDATE_SHOW_WA_SHARE_LINK_MSG_MODAL:
      return objectAssign({}, state, { showWAShareLinkMessageModal: action.data });
    case UPDATED_SHOW_WAITING_AREA_BEFORE_CALLS_IMPORTANT_INFO_MODAL:
      console.log('>>>>> UPDATED_SHOW_WAITING_AREA_BEFORE_CALLS_IMPORTANT_INFO_MODAL handle', state, action.data);
      return objectAssign({}, state, {
        showBeforeCallsImportantInfoModal: action.data,
      });
    case UPDATED_SHOW_UPDATE_WAITING_AREA_MODAL:
      return objectAssign({}, state, {
        showUpdateWaitingAreaModal: action.data,
      });
    case UPDATED_SHOW_VIEW_WAITING_AREA_MODAL:
      return objectAssign({}, state, { showViewWaitingAreaModal: action.data });
    case UPDATED_SHOW_UPDATE_WAITING_AREA_OPERATING_HOURS_MODAL:
      return objectAssign({}, state, {
        showUpdateWaitingAreaOperatingHoursModal: action.data,
      });
    case UPDATED_SHOW_VIEW_WAITING_AREA_OPERATING_HOURS_MODAL:
      return objectAssign({}, state, {
        showViewWaitingAreaOperatingHoursModal: action.data,
      });
    case UPDATED_SHOW_UPDATE_WAITING_AREA_LOCAL_ACCESS_HOURS_MODAL:
      return objectAssign({}, state, {
        showUpdateWaitingAreaLocalAccessHoursModal: action.data,
      });
    case UPDATED_SHOW_WAITING_AREA_LOGO_PAUSE_IMAGE_MODAL:
      return objectAssign({}, state, {
        showWaitingAreaLogoPauseImageModal: action.data,
      });
    case UPDATED_SHOW_ORGANISATIONAL_UNIT_LOGO_IMAGE_MODAL:
      return objectAssign({}, state, {
        showOrganisationalUnitLogoImageModal: action.data,
      });
    case UPDATED_SHOW_VIEW_WAITING_AREA_LOCAL_ACCESS_HOURS_MODAL:
      return objectAssign({}, state, {
        showViewWaitingAreaLocalAccessHoursModal: action.data,
      });
    case UPDATED_SHOW_QUICK_VIEW_MODAL:
      return objectAssign({}, state, { showQuickViewModal: action.data });
    case UPDATED_SHOW_CREATE_MEETING_ROOM_MODAL:
      return objectAssign({}, state, {
        showCreateMeetingRoomModal: action.data,
      });
    case UPDATE_SHOW_INVITE_GUEST_MODAL:
      return objectAssign({}, state, { showInviteGuestModal: action.data });
    case UPDATED_SHOW_VIEW_MEETING_ROOM_MODAL:
      return objectAssign({}, state, { showViewMeetingRoomModal: action.data });
    case UPDATED_SHOW_DELETE_MEETING_ROOM_MODAL:
      return objectAssign({}, state, {
        showDeleteMeetingRoomModal: action.data,
      });
    case UPDATED_SHOW_UPDATE_MEETING_ROOM_MODAL:
      return objectAssign({}, state, {
        showUpdateMeetingRoomModal: action.data,
      });
    case UPDATED_SHOW_VIEW_MEETING_ROOM_PARTICIPANT:
      return objectAssign({}, state, {
        showViewMeetingRoomParticipantModal: action.data,
      });
    // Show Edit meeting room properies modal
    case SHOW_EDIT_MEETING_ROOM_MODAL:
      return objectAssign({}, state, { showEditMeetingRoomModal: action.data });
    case UPDATED_SHOW_NOTIFY_ROOM_PARTICIPANT:
      return objectAssign({}, state, {
        showNotifyRoomParticipantModal: action.data,
      });
    case SHOW_CALL_HISTORY_MODAL:
      return objectAssign({}, state, { showCallHistoryModal: action.data });
    case UPDATED_HIDE_WHEN_CLICK_AWAY_QUICK_VIEW:
      return objectAssign({}, state, {
        hideWhenClickAwayQuickView: action.data,
      });
    case UPDATED_SHOW_WEBSITE_BUTTON_WAITING_AREA_MODAL:
      return objectAssign({}, state, {
        showWebsiteButtonWaitingAreaModal: action.data,
      });
    case UPDATE_SHOW_SUSPEND_WA_MODAL:
      return objectAssign({}, state, { showSuspendWAModal: action.data });
    case UPDATE_SHOW_CALLER_ENTRY_POINT:
      return objectAssign({}, state, { showCallerEntryModal: action.data });
    case UPDATE_SHOW_DURING_CALLS_MODAL:
      return objectAssign({}, state, { showDuringCallsModal: action.data });
    case UPDATED_SHOW_WAITING_AREA_ADD_USER_MODAL:
      return objectAssign({}, state, {
        showWaitingAreaAddUsersModal: action.data,
      });
    case UPDATED_SHOW_ORGANISATIONAL_UNIT_ADD_USER_MODAL:
      return objectAssign({}, state, {
        showOrganisationalUnitAddUsersModal: action.data,
      });
    // Manage roles on users list
    case SHOW_MANAGE_ROLES_FOR_USERS:
      return objectAssign({}, state, {
        showManageRolesForUsersModal: action.data,
      });
    // Manage roles on users list
    case SHOW_ORG_MANAGE_ROLES_FOR_USERS:
      return objectAssign({}, state, {
        showManageRolesForOrgUsersModal: action.data,
      });
    case UPDATE_SHOW_SET_MIN_DURATIONS_MODAL:
      return objectAssign({}, state, { showSetMinDurationsModal: action.data });
    case SHOW_MODAL:
      return objectAssign({}, state, { modalVisible: true });
    case HIDE_MODAL:
      return objectAssign({}, state, { modalVisible: false });
    case SHOW_COPY_LINK_TO_CLIPBOARD_MODAL_FOR_MEETING_ROOM:
      return objectAssign({}, state, {
        showCopyLinkToClipboardModalInMR: action.data,
      });
    case UPDATED_SHOW_VIEW_WA_INVITE_SELF_PROVISION:
      return objectAssign({}, state, {
        showWaitingAreaSelfProvisionModal: action.data,
      });
    case EDIT_UPDATE_PORTAL_SETTING:
      return objectAssign({}, state, {
        showEditPortalSetting: action.data,
      });
    case UPDATED_SHOW_REGISTERED_USER_WITH_WA_MODAL:
      return objectAssign({}, state, {
        showWaitingAreaSelfProvisionCreateModal: action.data,
      });
    case UPDATED_SHOW_WA_WELCOME_MODAL:
      return objectAssign({}, state, {
        showWaitingAreaWelcomeModal: action.data,
      });

    case SHOW_SUPPORT_CONTACT_MODAL:
      return objectAssign({}, state, {
        showSupportContactModal: action.data.showSupportContactModal,
      });

    case SHOW_INFO_FOR_CALLERS_MODAL:
      return objectAssign({}, state, {
        showInfoForCallersModal: action.data.showInfoForCallersModal,
      });
    // Deactivate Waiting Area
    case SHOW_DELETE_WA_MODAL:
      return objectAssign({}, state, { showDeleteWAModal: action.data });
    // Manage tags
    case SHOW_REMOVE_TAG_CONFIRMATION_MODAL:
      return objectAssign({}, state, {
        showRemoveTagConfirmationModal: action.data,
      });
    case SHOW_ASSIGN_TAGS_MODAL:
      return objectAssign({}, state, { showAssignTagsModal: action.data });
    case SHOW_EDIT_TAG_VALUE_MODAL:
      return objectAssign({}, state, { showEditTagValueModal: action.data });
    // OU Manage tags  SHOW_REMOVE_TAG_CONFIRMATION_MODAL_IN_OU,
    case SHOW_REMOVE_TAG_CONFIRMATION_MODAL_IN_OU:
      return objectAssign({}, state, {
        showRemoveTagConfirmationModalInOU: action.data,
      });
    case SHOW_ASSIGN_TAGS_MODAL_IN_OU:
      return objectAssign({}, state, { showAssignTagsModalInOU: action.data });
    case SHOW_EDIT_TAG_VALUE_MODAL_IN_OU:
      return objectAssign({}, state, {
        showEditTagValueModalInOU: action.data,
      });
    case UPDATED_SHOW_MY_ROLES_MODAL:
      return objectAssign({}, state, { showMyRolesModal: action.data });
    /********************************* Org Units **************************************/
    case SHOW_ORG_UNIT_GENERAL_INFO_MODALS:
      return objectAssign({}, state, {
        showOrgUnitGeneralInfoModal: action.data,
      });
    case SHOW_ORG_UNIT_SUPPORT_CONTACT_MODAL:
      return objectAssign({}, state, {
        showOrgUnitSupportContactModal: action.data,
      });
    case SHOW_ORG_UNIT_BEFORE_CALLS_WA_MODAL:
      return objectAssign({}, state, {
        showOrgUnitBeforeCallsWAModal: action.data,
      });
    case SHOW_ORG_UNIT_SHARE_LINK_WA_MODAL:
      return objectAssign({}, state, {
        showOrgUnitShareLinkWAModal: action.data,
      });

    /********************************* Org Units **************************************/
    // Meeting room reset guest Link
    case SHOW_MEETING_ROOM_RESET_GUEST_LINK_MODAL:
      return objectAssign({}, state, {
        showMeetingRoomResetGuestLink: action.data,
      });
    case SHOW_MEETING_ROOM_ADD_USERS_MODAL:
      return objectAssign({}, state, {
        showMeetingRoomAddUsersModal: action.data,
      });
    case SHOW_MR_MANAGE_ROLES_FOR_USERS:
      return objectAssign({}, state, {
        showMeetingRoomManageUsersRolesModal: action.data,
      });
    case SHOW_OTHER_USERS_PROFILE:
      return objectAssign({}, state, {
        showOtherUsersProfileModal: action.data,
      });
    case SHOW_OTHER_USERS_ROLES:
      return objectAssign({}, state, { showOtherUsersRolesModal: action.data });
    case SHOW_MANAGE_INVITATIONS_MODAL:
      return objectAssign({}, state, {
        showManageInvitationsModal: action.data,
      });
    case SHOW_CREATE_OU_MODAL:
      return objectAssign({}, state, { showCreateOUModal: action.data });
    case SHOW_SHARE_BY_EMAIL_WA:
      return objectAssign({}, state, { showShareByEmailModal: action.data });
    case SHOW_SHARE_BY_TEXT_WA:
      return objectAssign({}, state, { showShareByTextModal: action.data });
    case SHOW_CONFIRMATION_CALL_MESS_MODAL:
      return objectAssign({}, state, {
        showConfirmationCallMessModal: action.data,
        confirmationCallMessSuccessAction: action.successAction,
        callParticipants: action.participants,
        confirmationCallMessActionType: action.confirmationCallMessActionType,
      });
    case SHOW_CONSULT_NOW_INVITATION:
      return objectAssign({}, state, { showConsultNowInvitationModal: action.data });
    case SHOW_CANCEL_CONSULT_NOW_INVITATION_MODAL:
      return objectAssign({}, state, { showCancelCNInvitationModal: action.data });
    case SHOW_EXTEND_CONSULT_NOW_INVITATION_MODAL:
      return objectAssign({}, state, { showExtendCNInvitationModal: action.data });
    case SHOW_RECORDING_SETTING_MODAL:
      return objectAssign({}, state, { showOURecordingSettingModal: action.data });
    // WA-VIEWONE GC settings
    case SHOW_GC_SETTINGS_MODAL:
      return objectAssign({}, state, { showGCSettingsModal: action.data });
    // OU DEFAULT GC CHAT-FULLNAME CONTROL MODAL  SHOW_OU_DEFAULT_GC_SETTINGS_MODAL
    case SHOW_OU_DEFAULT_GC_SETTINGS_MODAL:
      return objectAssign({}, state, { showOuDefaultGcSettingsModal: action.data });
    // OU WA SETTING GC CHAT-FULLNAME CONTROL MODAL SHOW_OU_WA_GC_SETTINGS_MODAL
    case SHOW_OU_WA_GC_SETTINGS_MODAL:
      return objectAssign({}, state, { showOuWaGcSettingsModal: action.data });
    // Delete Organization
    case SHOW_DELETE_ORGANIZATION_MODAL:
      return objectAssign({}, state, { showDeleteOrganizationModal: action.data });
    default:
      return state;
  }
};
export default reducer;
